import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';

export const extractFieldFilter = (
  filter: CompositeFilterDescriptor | undefined,
  field: string
): FilterDescriptor | CompositeFilterDescriptor | undefined => {
  if (!filter) {
    return undefined;
  }

  return filter.filters.find(f => {
    if ('field' in f) {
      return f.field === field;
    }
    if ('filters' in f) {
      return f.filters.some(sf => 'field' in sf && sf.field === field);
    }
    return false;
  });
};

export const extractFilterValues = (filter: FilterDescriptor | CompositeFilterDescriptor): string[] => {
  if ('field' in filter) {
    return Array.isArray(filter.value) ? filter.value.map(String) : [String(filter.value)];
  }

  if ('filters' in filter) {
    return filter.filters
      .filter((f): f is FilterDescriptor => 'field' in f)
      .flatMap(f => (Array.isArray(f.value) ? f.value.map(String) : [String(f.value)]));
  }

  return [];
};

export const createFieldFilter = (
  currentFilter: CompositeFilterDescriptor | undefined,
  field: string,
  values: string[]
): CompositeFilterDescriptor => {
  const newFieldFilter: CompositeFilterDescriptor = {
    logic: 'or',
    filters: values.map(
      value =>
        ({
          field,
          operator: 'eq',
          value
        }) as FilterDescriptor
    )
  };

  if (!currentFilter) {
    return {
      logic: 'and',
      filters: [newFieldFilter]
    };
  }

  const otherFilters = currentFilter.filters.filter(f => {
    if ('field' in f) {
      return f.field !== field;
    }
    if ('filters' in f) {
      return !f.filters.some(sf => 'field' in sf && sf.field === field);
    }
    return true;
  });

  return {
    ...currentFilter,
    filters: [...otherFilters, newFieldFilter]
  };
};

export const removeFieldFilter = (
  currentFilter: CompositeFilterDescriptor | undefined,
  field: string
): CompositeFilterDescriptor | null => {
  if (!currentFilter) {
    return null;
  }

  const otherFilters = currentFilter.filters.filter(f => {
    if ('field' in f) {
      return f.field !== field;
    }

    if ('filters' in f) {
      return !f.filters.some(sf => 'field' in sf && sf.field === field);
    }

    return true;
  });

  if (otherFilters.length === 0) {
    return null;
  }

  return {
    ...currentFilter,
    filters: otherFilters
  };
};
